export const INSTAGRAM_OAUTH_MESSAGE_TYPE = 'twin-tales-instagram-oauth';

const POPUP_NAME = 'twin-tales-instagram-oauth';
const POPUP_FEATURES = 'width=520,height=720,scrollbars=yes,resizable=yes';

export function openInstagramOAuthWindow(authorizationUrl) {
  let win = null;
  try {
    win = window.open(authorizationUrl, POPUP_NAME, POPUP_FEATURES);
  } catch {
    win = null;
  }
  if (win) {
    try {
      win.focus();
    } catch {
      /* cross-origin */
    }
    return win;
  }
  try {
    win = window.open(authorizationUrl, '_blank');
    if (win) win.focus();
  } catch {
    win = null;
  }
  return win;
}

export function subscribeInstagramOAuthResult({ popupRef, onResult, onPopupClosed }) {
  const onMessage = (event) => {
    const data = event.data;
    if (!data || data.type !== INSTAGRAM_OAUTH_MESSAGE_TYPE) return;
    const popup = popupRef.current;
    if (popup && event.source && event.source !== popup) return;
    onResult({
      status: String(data.status || ''),
      message: String(data.message || ''),
    });
  };

  window.addEventListener('message', onMessage);

  let closedNotified = false;
  const intervalId = window.setInterval(() => {
    const popup = popupRef.current;
    if (!popup || !popup.closed || closedNotified) return;
    closedNotified = true;
    onPopupClosed?.();
  }, 400);

  return () => {
    window.removeEventListener('message', onMessage);
    window.clearInterval(intervalId);
  };
}
